import type { AfterViewInit } from '@angular/core';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import type { RCRFeeScheduleResponse } from '../shared/interfaces/rcrfeescheduleresponse.interface';
import { FeeScheduleService } from '../shared/services/fee-schedule.service';

@Component({
  standalone: false,
  selector: 'invd-fee-schedules',
  templateUrl: './fee-schedules.component.html',
  styleUrls: ['./fee-schedules.component.scss'],
})
export class FeeSchedulesComponent implements AfterViewInit {
  public rcrFeeScheduleData: any;

  private feeSccheduleService = inject(FeeScheduleService);
  private cdr = inject(ChangeDetectorRef);

  ngAfterViewInit() {
    this.feeSccheduleService.getExchangeFeeSchedule().subscribe({
      next: (data) => {
        this.handleRcrFeeResponse(data as RCRFeeScheduleResponse);
      },
      error: (_error) => {
        this.cdr.markForCheck();
      },
    });
  }

  private handleRcrFeeResponse(rcrFeeResponseObject: RCRFeeScheduleResponse) {
    this.rcrFeeScheduleData = rcrFeeResponseObject.feeSchedule;
    this.cdr.markForCheck();
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
